import React from 'react';
import './BarChart.css';

/**
 * BarChart – simple SVG-free CSS bar chart
 * @param {Array} data - [{ label, val, color? }]
 */
export default function BarChart({ data = [] }) {
  const max = Math.max(...data.map((d) => d.val), 1);

  return (
    <div className="bar-chart">
      {data.map((d, i) => (
        <div className="bar-chart__col" key={i}>
          <div
            className="bar-chart__bar"
            style={{ height: `${(d.val / max) * 100}%`, background: d.color || undefined }}
            title={String(d.val)}
          />
          <div className="bar-chart__label">{d.label}</div>
        </div>
      ))}
    </div>
  );
}
